import { Flex } from '@chakra-ui/react';

import { NthCalculator } from '@components/nth-calculator/nth-calculator';

import type { MergePurgeBodyProps } from './types/merge-purge-body.props';

import ReportGrid from './components/report-grid';
import { useMergePurgeBodyConfiguration } from './hooks/merge-purge-body-configuration.hook';

export default function MergePurgeBody({ mailingId, view }: MergePurgeBodyProps) {
  const { containerRef, isOpen, isResizing, leftPercent, onDividerMouseDown, setIsNthCalculatorOpen } =
    useMergePurgeBodyConfiguration();

  return (
    <Flex
      p={1}
      pb="0!"
      ref={containerRef}
      w="full">
      <Flex
        borderColor="gray.500"
        borderRadius={isOpen ? 'xl' : 'none'}
        borderWidth={isOpen ? '1px' : '0'}
        flexBasis={isOpen ? `${leftPercent}%` : '100%'}
        minW={0}
        overflow="hidden"
        transition={isResizing ? 'none' : 'border-radius 0.3s ease, flex-basis 0.3s ease'}>
        <ReportGrid
          mailingId={mailingId}
          view={view}
        />
      </Flex>
      <Flex
        bg="gray.500"
        cursor="ew-resize"
        display={isOpen ? 'flex' : 'none'}
        mx={2}
        onMouseDown={onDividerMouseDown}
        w={1}
      />
      <Flex
        borderColor="purple.600"
        borderRadius={isOpen ? 'xl' : 'none'}
        borderWidth={isOpen ? '1px' : '0'}
        flexBasis={isOpen ? `${100 - leftPercent}%` : '0%'}
        minW={0}
        opacity={isOpen ? 1 : 0}
        overflow="hidden"
        transition={isResizing ? 'none' : 'flex-basis 0.3s ease, opacity 0.3s ease'}>
        {isOpen && (
          <NthCalculator
            mailingId={mailingId}
            onNewWindow={() => {
              setIsNthCalculatorOpen(false);
            }}
            view="summary"
          />
        )}
      </Flex>
    </Flex>
  );
}
